import {
  AnyAction,
  CombinedState,
  combineReducers,
  configureStore,
  Reducer,
} from '@reduxjs/toolkit'
import authSlice from './features/auth/authSlice'
import basicInfoSlice from './features/basicInfo/basicInfoSlice'
import dashboardUiSlice from './features/dashboardUi/dashboardUiSlice'
import paymentSlice from './features/payment/paymentSlice'
import preReserveSlice from './features/per-reserve/preReserveSlice'
import publicPreReserveSlice from './features/per-reserve/publicPreReserve/publicPreReserveSlice'
import reserveNewPreReserveSlice from './features/per-reserve/reserveNewPreReserve/reserveNewPreReserveSlice'
import pilgrimSlice from './features/pilgrim/pilgrimSlice'
import proclamationSlice from './features/proclamation/proclamationSlice'
import reportSlice from './features/report/reportSlice'

const reducer = {
  dashboardUi: dashboardUiSlice,
  auth: authSlice,
  proclamation: proclamationSlice,
  basicInfo: basicInfoSlice,
  preReserve: preReserveSlice,
  reserveNewPreReserve: reserveNewPreReserveSlice,
  publicPreReserve: publicPreReserveSlice,
  payment: paymentSlice,
  report: reportSlice,
  pilgrim: pilgrimSlice,
}

const rootReducer = combineReducers(reducer)

const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined,
  action: AnyAction,
) => {
  if (action.type === 'auth/logoutUser') {
    return rootReducer(undefined, action)
  }

  return rootReducer(state, action)
}
const store = configureStore({
  reducer: resettableRootReducer,
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store
